const getActiveTabBar = ({ isArchived }: { isArchived: boolean }) => {
  if (isArchived) return 'archived'
  return 'active'
}

export default getActiveTabBar
